<template>
    <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;" v-if="haveBom">
        <div class="h-rowCon" style="padding-bottom:0">
            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                <div class="h-pieceTitle2"
                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                    <h1>Bom信息</h1>
                </div>
            </div>

            <el-table
                    :data="bomData"
                    style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-table
                            ref="multipleTable"
                            :data="props.row.bomDetailList"
                            stripe
                            style="width: 100%"
                            :border="true">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="prodcode"
                                label="产品编码">
                        </el-table-column>
                        <el-table-column
                                prop="promodel"
                                label="产品型号">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                label="数量">
                        </el-table-column>
                        <el-table-column
                                prop="unit"
                                label="单位">
                        </el-table-column>
                        <el-table-column
                                prop="protype"
                                label="型号属性">
                        </el-table-column>
                    </el-table>
                    </template>
                </el-table-column>


                <el-table-column
                        prop="prodcode"
                        label="产品编码">
                </el-table-column>
                <el-table-column
                        prop="promodel"
                        label="产品型号">
                </el-table-column>
                <el-table-column
                        prop="factory"
                        label="工厂">
                </el-table-column>
                <el-table-column
                        prop="version"
                        label="版本号">
                </el-table-column>


            </el-table>



        </div>
    </div>

</template>

<script>
    import ss from "../../api/SystemService";

    export default {

        props: ["bomCodeList","byMainId"],

        data() {
            return {
                bomData: [],

                data:[],
                haveBom: false,
                bomCodeListCopy:[],


            }
        },

        methods:{
            arrayEquals(array1,array2) {
                return array1.length==array2.length && array1.every(function(v,i) { return v === array2[i]});
            }

        },

        watch:{

            bomCodeList: function (bomCodeList) {

                if(bomCodeList.length==0){
                    this.haveBom = false;
                    this.bomData =[];
                    return [];
                }

                this.data = bomCodeList;
                if(this.data.constructor!== Array){
                    this.data = bomCodeList.split(',');
                }
                //判断是否与之前编码相同
                if(this.arrayEquals(this.data,this.bomCodeListCopy)){
                    return;
                }else{
                    this.bomCodeListCopy =bomCodeList;
                }

                if(this.byMainId){
                    ss.bom.selectByIdList(this.data).then(rd => {
                        this.bomData = rd;
                        if(this.bomData.length>0){
                            this.haveBom = true;
                        }else{
                            this.haveBom = false;
                        }
                    })
                }else{
                    ss.bom.selectByProdcode(this.data).then(rd => {
                        this.bomData = rd;
                        if(this.bomData.length>0){
                            this.haveBom = true;
                        }else{
                            this.haveBom = false;
                        }
                    })
                }




            }

        },
        created(){
            if(this.bomCodeList.length==0){
                this.haveBom = false;
                this.bomData =[];
                return [];
            }
            this.data = this.bomCodeList;
            if(this.data.constructor!== Array){
                this.data = this.bomCodeList.split(',');
            }
            if(this.byMainId){
                ss.bom.selectByIdList(this.data).then(rd => {
                    this.bomData = rd;
                    if(this.bomData.length>0){
                        this.haveBom = true;
                    }else{
                        this.haveBom = false;
                    }
                })
            }else{
                ss.bom.selectByProdcode(this.data).then(rd => {
                    this.bomData = rd;
                    if(this.bomData.length>0){
                        this.haveBom = true;
                    }else{
                        this.haveBom = false;
                    }
                })


            }




        },









    }

</script>

<style>
    .ljjtablepaddings12 .h-tableInput .el-input__inner {
        padding: 0.05rem 0.1rem;
    }

    .ljjtablepaddings12 .h-tableInput .el-input__icon {
        line-height: 0.25rem;
    }


</style>